import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import {
    getToyTitleByKey,
    PERIOD,
    TITLE,
} from '../../../../../../constants/shared/CommonConstants';
import './TrcSummaryTable.scss';
import TableRow from './TableRow/TableRow';
import TableHeader from './TableRow/TableHeader';
import { HEADER_TITLES } from './TableRow/tableRowUtils';
import { generateReactKey } from '../../../../../../utils/shared/commonUtils';

const TrcSummaryTable = ({
    isPresumed,
    books,
    resultId,
    openProbeDetails,
    period,
    summeryLabel,
}) => {
    const headerTitle = `${getToyTitleByKey(period, summeryLabel)} ${
        period === PERIOD.SUMMER ? '' : `(${period})`
    }`;
    return (
        <div className="information-table">
            <p className="header">
                <strong>{headerTitle}</strong>
            </p>
            {!isEmpty(books) && !isPresumed && <TableHeader titles={HEADER_TITLES} />}
            {isPresumed ? (
                <p>
                    A book level marked with PS indicates a presumed level. No TRC assessment
                    occurred in that period, so no item-level details are available.
                </p>
            ) : (
                books.map((book, index) => {
                    const { interp, correctWrittenComp } = book;
                    const isFirstRow = index === 0;

                    return (
                        <TableRow
                            key={generateReactKey(index)}
                            additionalClasses={`${interp} ${isFirstRow && 'row-border-top'}`}
                            book={book}
                            writtenComp={correctWrittenComp(book)}
                            onBookTitleClick={() => openProbeDetails(resultId, book.bookId)}
                        />
                    );
                })
            )}
        </div>
    );
};

TrcSummaryTable.defaultProps = {
    isPresumed: false,
    books: [],
    resultId: null,
    openProbeDetails: () => {},
    period: '',
    summeryLabel: TITLE.SUMMER_TITLE,
};

TrcSummaryTable.propTypes = {
    isPresumed: PropTypes.bool,
    books: PropTypes.arrayOf(PropTypes.object),
    resultId: PropTypes.string,
    openProbeDetails: PropTypes.func,
    period: PropTypes.string,
    summeryLabel: PropTypes.string,
};

export default TrcSummaryTable;
